@if (loading$ | async) {
  <div
    style="position: absolute; top: 0; right: 0; left: 0; z-index: 9999; background-color: #fff"
    >
    <p-progressBar
      data-smartpresentation="barra-carregamento"
      mode="indeterminate"
      [style]="{ height: '5px' }"
    ></p-progressBar>
  </div>
}
<div
  class="layout-wrapper"
  [ngClass]="{
    'layout-compact-menu': menuCompactMode,
    'layout-menu-static': isStatic(),
    'layout-menu-overlay': isOverlay(),
    'layout-menu-horizontal': isHorizontal(),
    'layout-menu-slim': isSlim(),
    'layout-menu-active': menuActive && (menuVisible$ | async),
    'layout-menu-mobile-active': mobileMenuActive,
    'layout-topbar-mobile-active': mobileTopbarActive
  }"
  [class]="'layout-menu-' + layoutConfig.menuTheme + ' layout-topbar-' + layoutConfig.topbarTheme"
  >
  @if (!(fullscreen$ | async)) {
    <app-topbar></app-topbar>
  }

  @if (menuVisible$ | async) {
    <div class="menu-wrapper shadow-none" (click)="onMenuClick($event)">
      <div class="layout-menu-container justify-content-between">
        <!-- <app-menu></app-menu> -->
        <app-inline-menu key="bottom" [isCompact]="menuCompactMode"></app-inline-menu>
        <div
          class="flex my-4 px-3"
        [ngClass]="
          menuCompactMode ? 'align-items-center justify-content-center' : 'align-items-center justify-content-between'
        "
          >
          <img
          [src]="
            menuCompactMode
              ? 'assets/images/simbolo-blendus-principal.svg'
              : 'assets/images/logo-blendus-horizontal-escuro.svg'
          "
            alt="Blendus"
            [style.height]="menuCompactMode ? '27px' : '21px'"
            [style.margin]="menuCompactMode ? '0 4px -3px 0' : '0'"
            />
        </div>
      </div>
    </div>
  }

  <div class="layout-main" [ngClass]="{ 'layout-fullscreen': (fullscreen$ | async) }">
    <!-- <app-breadcrumb *ngIf="!(fullscreen$ | async)"></app-breadcrumb> -->

    <div class="layout-content flex flex-column">
      <router-outlet></router-outlet>
    </div>

    <p-toast [preventOpenDuplicates]="true"></p-toast>
    <!-- <app-footer *ngIf="!(fullscreen$ | async)"></app-footer> -->
  </div>

  @if (mobileMenuActive) {
    <div class="layout-mask modal-in"></div>
  }

  <!-- Blendus Cookie Policy -->
  @if (showCookieBanner$ | async) {
    <div class="cookie-banner">
      <div class="flex justify-content-between align-items-center">
        <div class="cookie-banner-text">
          Utilizamos cookies para melhorar sua experiência no Gestor IDSS.<br />
          Você pode aceitar todos os cookies ou apenas os essenciais,<br />
          o que limitará algumas funcionalidades do sistema.
          <br />
          <br />
          <a class="cookie-link" href="/assets/lgpd/politica-cookie.pdf" target="_blank" rel="noopener">
            Política de cookies <i class="pi pi-external-link text-xs"></i>
          </a>
          <br />
          <br />
          <div class="cookie-actions">
            <button type="button" pButton class="p-button-md cookie-accept mr-2" (click)="cookieBannerAceitarTodos()">
              Aceitar todos
            </button>
            <button
              type="button"
              pButton
              class="p-button-md p-button-outlined cookie-essential"
              (click)="cookieBannerAceitarNecessarios()"
              >
              Essenciais
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <!--
  Pesquisa NPS: ocupa o mesmo ponto do cookie banner. Só é montada depois que o cookie
  banner é dispensado (showCookieBanner == false), então os dois nunca aparecem juntos.
  A elegibilidade (regra de reexibição) é decidida dentro do próprio componente.
  -->
  @if ((showCookieBanner$ | async) === false) {
    <bl-pesquisa-nps-dialog
      [cdPesquisa]="npsCdPesquisa"
    ></bl-pesquisa-nps-dialog>
  }

  <bl-aviso-inatividade></bl-aviso-inatividade>
</div>
